// src/pages/ESG/index.jsx (또는 기존 ESG.jsx 파일)
import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { AnimatedSection } from '../../components/common/AnimatedSection';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
  padding-top: 10%;
  @media (max-width: 768px) {
    padding-top: 30%;
  }
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 3rem;

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0 0;
`;

const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #111111;
  letter-spacing: -1px;
`;

const PageSubtitle = styled.p`
  font-size: 1.1rem;
  color: #6b7280;
  font-weight: 400;
  margin-top: 0.75rem;
`;

const float = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
  100% { transform: translateY(0); }
`;

const PlaceholderWrap = styled.div`
  display: grid;
  place-items: center;
  text-align: center;
  padding: 6rem 0 8rem;
`;

const IconWrap = styled.div`
  width: 140px;
  height: 140px;
  border-radius: 24px;
  display: grid;
  place-items: center;
  margin-bottom: 20px;
  animation: ${float} 2.4s ease-in-out infinite;

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }
`;

const Img = styled.img`
  max-width: 86px;
  max-height: 86px;
  object-fit: contain;
  display: block;
  opacity: 0.95;
`;

const Emoji = styled.div`
  font-size: 96px;
  line-height: 1;
`;

const BigText = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: #111;
  margin: 0 0 8px;
`;

const SmallText = styled.p`
  font-size: 1.1rem;
  color: #6b7280;
  margin: 0;
`;

function ESG() {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [bodyRef, bodyVisible] = useScrollAnimation();
  const [imgError, setImgError] = useState(false);

  // 공사중 이미지 경로(있으면 사용, 없으면 이모지로 대체)
  const underConstructionSrc = '/images/under-construction.svg'; // 또는 .png

  return (
    <PageContainer>
      <Container>
        {/* <AnimatedSection ref={headerRef} isVisible={headerVisible} animation="fadeInUp">
          <PageHeader>
            <PageTitle>ESG 경영</PageTitle>
            <PageSubtitle>세연이앤에스의 ESG 페이지는 현재 준비 중입니다.</PageSubtitle>
          </PageHeader>
        </AnimatedSection> */}

        <AnimatedSection ref={bodyRef} isVisible={bodyVisible} animation="fadeInUp" delay="0.12s">
          <PlaceholderWrap>
            <IconWrap>
              {!imgError ? (
                <Img
                  src={underConstructionSrc}
                  alt="공사 중"
                  onError={() => setImgError(true)}
                />
              ) : (
                <Emoji>🚧</Emoji>
              )}
            </IconWrap>

            <BigText>제작 중인 페이지입니다</BigText>
            <SmallText>빠르게 준비해서 찾아뵙겠습니다.</SmallText>
          </PlaceholderWrap>
        </AnimatedSection>
      </Container>
    </PageContainer>
  );
}

export default ESG;
